var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.status === 'loading')?_c('k-spinner',{attrs:{"height":"500px"}}):_c('image-style-list-table',{attrs:{"items":_vm.imageStyles,"client-id":_vm.clientId,"site-id":_vm.siteId,"ro":_vm.ro}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }